export default __webpack_public_path__ + "static/media/1.864badf3.jpg";